module.exports = __webpack_public_path__ + "static/media/9-fullt.4169ed00.mp3";